/**
 * Swing `Action.doVerify`: enabled by action XML verification flag.
 * In platform XML this can come as `<verify>` or legacy `<Check>`.
 * Field `verify_re` is not a reason to block the action.
 */
export function isActionXmlVerifyEnabled(actionData: unknown): boolean {
  if (actionData == null || typeof actionData !== 'object') return false
  const rec = actionData as Record<string, unknown>
  const node = rec.verify ?? rec.Verify ?? rec.check ?? rec.Check
  const raw = node != null && typeof node === 'object' && '_text' in node
    ? (node as { _text?: unknown })._text
    : node
  const n = String(raw ?? '').trim().toLowerCase()
  return n === 'true' || n === '1'
}
